import { render, staticRenderFns } from "./RFEntryPop.vue?vue&type=template&id=08c1d1a1"
import script from "./RFEntryPop.vue?vue&type=script&lang=js"
export * from "./RFEntryPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08c1d1a1')) {
      api.createRecord('08c1d1a1', component.options)
    } else {
      api.reload('08c1d1a1', component.options)
    }
    module.hot.accept("./RFEntryPop.vue?vue&type=template&id=08c1d1a1", function () {
      api.rerender('08c1d1a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/RFEntryPop.vue"
export default component.exports